<template>
  <form-capsule :formTitle="$t('suppliers.form_invoice_create_title')">
    <template slot="formcontent">
      <b-row>
        <b-col>
          <form-write-group-label-input v-model="invoiceName" isMandatory
            :idLabel="$t('common.mtf')"
            :mandatoryErrorIndicator="invoiceNameError">
          </form-write-group-label-input>
        </b-col>
        <b-col>
          <form-write-group-label-input v-model="invoiceIdentifier" isMandatory
            :idLabel="$t('common.invoiceid_label')"
            :mandatoryErrorIndicator="invoiceIdentifierError">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <form-write-group-label-input v-model="amount" isMandatory
            inputType="number"
            :idLabel="$t('common.amnt')" :placeholderValue="$t('common.amnt')">
          </form-write-group-label-input>
        </b-col>
        <b-col>
          <form-write-group-label-input v-model="executionDate" isMandatory
            inputType="date" disablePastDates
            :idLabel="$t('common.execution_date_label')"
            :placeholderValue="$t('common.slct_date')">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6">
          <form-write-group-label-input isMandatory
            inputType="listeSelect"
            :idLabel="$t('common.invoice_type')"
            :mandatoryErrorIndicator="typeError">
            <select v-model="type" class="form-control" readonly>
              <option value="">{{ $t('suppliers.slct_invoice_type') }}</option>
              <option v-for="invoiceType in invoiceTypeList" :key="invoiceType.invoiceTypeValue"
                :value="invoiceType.invoiceTypeValue"
                :disabled="invoiceType.disabled"
                :style="invoiceType.disabled ? 'font-style:italic;' : ''">
                {{ $t(invoiceType.invoiceTypeLabel) }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6">
          <form-write-group-label-input
            :idLabel="$t('suppliers.supplier')"
            :inputType="'listeSelect'">
            <select v-model="sellerId" class="form-control" readonly
              @change="getGroups">
              <option value="">{{ $t('suppliers.slct_supplier') }}</option>
              <option v-for="seller in sellerList" :key="seller.IdSeller" :value="seller.IdSeller">
                {{ seller.SocialReason }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
        <b-col v-if="groupList.length > 0">
          <form-write-group-label-input
            inputType="listeSelect"
            :idLabel="$t('suppliers.supplier')">
            <select v-model="groupId" class="form-control" readonly>
              <option value="">{{ $t('suppliers.slct_payment_group') }}</option>
              <option v-for="group in groupList" :key="group.IdGroup" :value="group.IdGroup">
                {{ group.Name }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </template>
    <template slot="footerbuttons">
      <b-row class="justify-content-start">
        <b-col md="3" offset-md="8">
          <button round
            class="button-action firstButtonMarginTop milkyBlockBlack"
            @click="createInvoice">
            <i class="icon fa fa-save"></i>
            {{ $t('suppliers.form_invoice_create_button') }}
          </button>
        </b-col>
      </b-row>
    </template>
  </form-capsule>
</template>
<script>
import moment from 'moment'
import formCapsule from '@/components/common/formCapsule.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import {verifyMandatoryValues, checkErrorFlag} from '@/helpers/validator'
/** @author JPR 26/08/2021
* @brief Component for adding Projects
*/
export default {
  name: 'CreateInvoiceForm',
  components: {
    'form-capsule': formCapsule,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      amount: '',
      amountError: false,
      date: '',
      executionDate: '',
      invoiceName: '',
      invoiceNameError: false,
      invoiceIdentifier: '',
      invoiceIdentifierError: false,
      invoiceTypeList: [
        {
          disabled: false,
          invoiceTypeLabel: 'AdvancePayment',
          invoiceTypeValue: 'AdvancePayment'
        },
        {
          disabled: false,
          invoiceTypeLabel: 'Comission',
          invoiceTypeValue: 'Comission'
        },
        {
          disabled: false,
          invoiceTypeLabel: 'Intermediate',
          invoiceTypeValue: 'Intermediate'
        },
        {
          disabled: false,
          invoiceTypeLabel: 'Balance',
          invoiceTypeValue: 'Balance'
        }
      ],
      groupId: '',
      groupList: [],
      sellerId: '',
      sellerList: [],
      type: '',
      typeError: false
    }
  },
  created () {
    let that = this
    this.executionDate = moment().add(1, 'day').format('YYYY-MM-DD')
    this.$engine.services.suppliers.update(
      0,
      1000000,
      0
    ).then(resp => {
      that.sellerList = resp.data.Sellers
    }).catch(error => {
      errorMessageAlert(error, that, that.$i18n)
    })
  },
  methods: {
    createInvoice () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }

      this.$f7.showPreloader(this.$i18n.t('loading.adding_invoice'))
      let that = this

      this.$engine.services.suppliers.createInvoice({
        InvoiceIdentifier: this.invoiceIdentifier,
        NameSeller: this.invoiceName,
        Date: moment().format('YYYY-MM-DD'),
        // PaymentDate: moment(this.executionDate).format('YYYY-MM-DD'),
        Amount: this.amount,
        Type: this.type,
        IdGroupPayment: this.groupId,
        IdSeller: this.sellerId
      })
      .then(response => {
        that.status = response.status
        if (response.status === 200 || response.status === 201) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: that.$i18n.t('success.invoice_added'),
            text: '<i class="icon fa fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.$engine.services.suppliers.selectedSupplier.IdSeller = that.sellerId
            loadPage(that, { url: '/suppliers/details/' })
            // reloadPage(that, {url: '/inbox/', force: true, ignoreCache: true})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getGroups () {
      let that = this
      this.groupId = ''
      this.activateSpinner = true
      this.$engine.services.suppliers.getPaymentGroups({
        IdSeller: this.sellerId
      }).then(resp => {
        that.groupList = resp.data.groups
        that.activateSpinner = false
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    validateForm () {
      let flagsList = {}
      let mandatoryValues = ['amount', 'invoiceIdentifier', 'invoiceName']
      /* IdSeller peut ne pas être obligatoire, potentiellement un if à ajouter */
      mandatoryValues.push('sellerId')
      /* IdGroup peut ne pas être obligatoire, potentiellement un if à ajouter */
      mandatoryValues.push('groupId')
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    }
  }
}
</script>



// WEBPACK FOOTER //
// InvoiceCreateTemplate.vue?01a58540